<template>
  <div>
    <div><b>Transaction Types</b></div>

    <apexchart id="report_metric_tx_types"
               type=line
               v-bind:options="tx_types_options"
               :series="series" />
  </div>
</template>

<script>
import util from '../../../util';

export default {
  name: 'MetricsTxTypes',

  props : {
    subreport : {
      type : Boolean,
      defalt : false
    }
  },

  computed : {
    period : function(){
      return this.subreport ? this.$store.state.report.selected.subperiod :
                              this.$store.state.report.period;
    },

    data : function(){
      const source = this.subreport ? this.$store.state.report.subreport :
                                      this.$store.state.report.data;

      var data = {};

      Object.keys(source["payments"]).forEach(function(d){
        data[d] = {payments : source["payments"][d]};
      }.bind(this));

      Object.keys(source["offers"]).forEach(function(d){
        if(!data[d]) data[d] = {}

        data[d]['offers_created']   = source["offers"][d]['created'];
        data[d]['offers_cancelled'] = source["offers"][d]['cancelled'];
      }.bind(this));

      return data;
    },

    series : function(){
      var payments         = Object.values(this.data).map(function(d){ return d['payments'] });
      var offers_created   = Object.values(this.data).map(function(d){ return d['offers_created'] });
      var offers_cancelled = Object.values(this.data).map(function(d){ return d['offers_cancelled'] });

      return [{
        name : "Payments",
        data: payments
      }, {
        name : "Offers Created",
        data : offers_created
      }, {
        name : "Offers Cancelled",
        data : offers_cancelled
      }];
    },

    tx_types_options : function(){
      return {
        chart: {
           animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 100,
                animateGradually: {
                    enabled: true,
                    delay: 100
                },
                dynamicAnimation: {
                    enabled: true,
                    speed: 150
                }
            }
        },
        xaxis : {
          type: 'datetime',
          categories : Object.keys(this.data)
        },

        tooltip : {
          x : { show : false, format : this.period == '86400' ? 'yyyy-MM-dd' : "yyyy-MM-dd HH:mm" }
        },

        yaxis : {
          labels : {
            formatter : function(v){
              return util.delim_value(util.round_value(v, 3));
            }
          },

          min : 0
        }
      };
    }
  }
}
</script>
